import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

export const getLoanApplicationCurrency = async (id: number) => {
  const { data } = await getData(
    `${ajaxEndpoints.LOAN_APPLICATIONS_CURRENCY}/${id}`
  );
  return data;
};

export default function useLoanApplicationCurrency(id: number) {
  return useQuery([id, "loanApplicationCurrency"], getLoanApplicationCurrency, {
    refetchOnWindowFocus: false,
  });
}
